/**
 * Formatadores de valor para leitura (read-only) de respostas.
 *
 * Usados por `FormAnswersView` para renderizar `answers` brutos como
 * texto legível. Separado do componente de render para manter o .tsx
 * focado em JSX e respeitar o target de 200 linhas de componente.
 *
 * **Por que não reusar `features/leads/formatters.ts`?** Os formatters
 * de lead assumem inputs limpos (pós-normalização do `normalizeLeadInput`).
 * Aqui recebemos respostas que podem ter vindo de um auto-cadastro
 * onde o prospect digitou do jeito dele — defensivo contra lixo.
 */

/** Formata telefone brasileiro de dígitos para (XX) XXXXX-XXXX. Se o
 * tamanho não bater (ex: user digitou ramal), devolve o valor cru. */
export function formatTelAnswer(raw: string): string {
  const digits = raw.replace(/\D/g, '');
  if (digits.length === 11) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }
  return raw;
}

/** Formata CNPJ para XX.XXX.XXX/XXXX-XX. Retorna raw se comprimento inesperado. */
export function formatCnpjAnswer(raw: string): string {
  const digits = raw.replace(/\D/g, '');
  if (digits.length !== 14) return raw;
  return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8, 12)}-${digits.slice(12)}`;
}

/** Formata CEP para XXXXX-XXX. Retorna raw se comprimento inesperado. */
export function formatCepAnswer(raw: string): string {
  const digits = raw.replace(/\D/g, '');
  if (digits.length !== 8) return raw;
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
}
